import { ComplianceLevel } from './levels';

/**
 * Capabilities unlocked by a compliance level. Add a field here (and a value
 * per level below) when a new feature needs gating — only that field's
 * consumer changes. Do not add fields nobody reads yet.
 */
export type ComplianceProfile = {
  level: ComplianceLevel;
  /** Whether the Billing History feature is available in this mode. */
  billingHistory: boolean;
  /** Whether settings cancellation skips retention and enters the cancellation form directly. */
  directCancellationFromSettings: boolean;
};

export const COMPLIANCE_PROFILES: Record<ComplianceLevel, ComplianceProfile> = {
  [ComplianceLevel.LEGACY]: {
    level: ComplianceLevel.LEGACY,
    billingHistory: false,
    directCancellationFromSettings: false,
  },
  [ComplianceLevel.V1]: {
    level: ComplianceLevel.V1,
    billingHistory: false,
    directCancellationFromSettings: false,
  },
  [ComplianceLevel.V2]: {
    level: ComplianceLevel.V2,
    billingHistory: true,
    directCancellationFromSettings: true,
  },
};
